import { __assign, __rest } from "tslib";
import React from 'react';
import { AccordionRow } from '@at/design-system-elements';
import { StyledAccordionListContainer } from './accordion-list.styled';
export var AccordionList = function (_a) {
    var items = _a.items, fullHeight = _a.fullHeight, fullBorder = _a.fullBorder, _b = _a.trackingCallback, trackingCallback = _b === void 0 ? function () { } : _b, otherHTMLProperties = __rest(_a, ["items", "fullHeight", "fullBorder", "trackingCallback"]);
    var handleRowClick = function (_a) {
        var rowIndex = _a.rowIndex, _b = _a.isExpanded, isExpanded = _b === void 0 ? false : _b;
        var rowInteractionData = { rowIndex: rowIndex, isExpanded: isExpanded };
        trackingCallback(rowInteractionData);
    };
    return (React.createElement(StyledAccordionListContainer, __assign({}, otherHTMLProperties), items.map(function (props, index) {
        return (React.createElement(AccordionRow, __assign({}, props, { expanded: props.isExpanded, handleRowClick: handleRowClick, key: index, rowIndex: index, fullBorder: fullBorder, fullHeight: fullHeight })));
    })));
};
